// frontend/admin-portal/src/components/procurement/ComparisonSummaryCards.jsx
import React from "react";
import { Card, Badge } from "@fiberhome/shared-ui";

export default function ComparisonSummaryCards({ comparison }) {
  if (!comparison) return null;
  const { suppliers, items, globallyMissingRfqItemIds, bestOverallSupplierId } =
    comparison;

  const quoted = suppliers.filter((s) => s.quotation);

  return (
    <div className="row g-3 mb-3">
      <div className="col-md-3 col-sm-6">
        <Card hoverable>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Suppliers Requested
          </div>
          <h2 className="mb-0">{suppliers.length}</h2>
        </Card>
      </div>
      <div className="col-md-3 col-sm-6">
        <Card hoverable>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Quotes Received
          </div>
          <h2 className="mb-0">
            {quoted.length} / {suppliers.length}
          </h2>
        </Card>
      </div>
      <div className="col-md-3 col-sm-6">
        <Card hoverable>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Items Requested
          </div>
          <h2 className="mb-0">{items.length}</h2>
        </Card>
      </div>
      <div className="col-md-3 col-sm-6">
        <Card hoverable>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Items Missing Everywhere
          </div>
          <h2
            className="mb-0"
            style={{
              color: globallyMissingRfqItemIds.length
                ? "var(--fh-danger)"
                : undefined,
            }}
          >
            {globallyMissingRfqItemIds.length}
          </h2>
        </Card>
      </div>

      {quoted.length > 0 && (
        <div className="col-12">
          <Card title="Supplier Overview">
            <div className="fh-cmp-suppliers-grid">
              {quoted.map((s) => {
                const isBest = s.supplier.id === bestOverallSupplierId;
                return (
                  <div
                    key={s.rfqId}
                    className={`fh-cmp-supplier-card ${isBest ? "is-best" : ""}`}
                  >
                    <div className="d-flex justify-content-between align-items-start gap-2">
                      <div>
                        <div style={{ fontWeight: 600 }}>{s.supplier.name}</div>
                        <div className="text-muted" style={{ fontSize: 11.5 }}>
                          {s.quotation.code}
                        </div>
                      </div>
                      {isBest && <Badge variant="success">Best</Badge>}
                    </div>
                    <div
                      className="mt-2"
                      style={{ fontSize: 20, fontWeight: 700 }}
                    >
                      {s.quotation.currency} {Number(s.total).toLocaleString()}
                    </div>
                    <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                      Covers {s.offeredCount} / {items.length} items
                      {s.missingCount > 0 && ` · ${s.missingCount} missing`}
                    </div>
                    {s.quotation.deliveryDays != null && (
                      <div className="text-muted" style={{ fontSize: 12 }}>
                        Delivery: {s.quotation.deliveryDays} day(s)
                      </div>
                    )}
                    {s.quotation.validUntil && (
                      <div className="text-muted" style={{ fontSize: 12 }}>
                        Valid until {s.quotation.validUntil}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
